<template>
    <li>
        <div class="inner">
            <button type="button" class="move">Move Item</button>
            <span class="name">
                <svg width="16" height="16" area-hidden="true">
                    <use href="/img/svg/symbol-defs.svg#icon-cinema"></use>
                </svg>
                {{ category.name }}
            </span>
            <div class="subcategory">
                <button type="button" class="subcategory__more">
                    <svg width="16" height="16" class="icon">
                        <use href="/img/svg/symbol-defs.svg#icon-dots"></use>
                    </svg>
                </button>
                <div class="subcategory__tool">
                    <a
                        @click.prevent="editMainSubcategory"
                        href="javascript:void(0)"
                        class="subcategory__action"
                    >
                        <svg width="16" height="16" class="icon">
                            <use href="/img/svg/symbol-defs.svg#icon-edit"></use>
                        </svg>
                        Edit
                    </a>
                    <button
                        type="button"
                        class="subcategory__action"
                        @click.prevent="deleteMainSubcategory"
                    >
                        <svg width="16" height="16" class="icon">
                            <use href="/img/svg/symbol-defs.svg#icon-close-9"></use>
                        </svg>
                        Delete
                    </button>
                </div>
            </div>
        </div>

            <ul>
                <draggable v-model="subcategory.subcategories" @end="onDragEnd()">
                <li
                    v-for="(subcategory, index) in subcategory.subcategories"
                    :key="`sub-${index}`">
                    <div class="inner">
                        <button type="button" class="move">Move Item</button>
                        <span class="name">
                        <svg width="16" height="16">
                            <use href="/img/svg/symbol-defs.svg#icon-cinema"></use>
                        </svg>
                        {{ subcategory.name }}
                    </span>
                        <div class="subcategory">
                            <button type="button" class="subcategory__more">
                                <svg width="16" height="16" class="icon">
                                    <use href="/img/svg/symbol-defs.svg#icon-dots"></use>
                                </svg>
                            </button>
                            <div class="subcategory__tool">
                                <a
                                    class="subcategory__action"
                                    @click.prevent="openModal(subcategory, index)"
                                >
                                    <svg width="16" height="16" class="icon">
                                        <use href="/img/svg/symbol-defs.svg#icon-edit"></use>
                                    </svg>
                                    Edit
                                </a>
                                <button
                                    type="button"
                                    class="subcategory__action"
                                    @click.prevent="deleteSubcategory(subcategory, index)"
                                >
                                    <svg width="16" height="16" class="icon">
                                        <use href="/img/svg/symbol-defs.svg#icon-close-9"></use>
                                    </svg>
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </li>
                </draggable>
            </ul>

        <div class="add-link mt-1">
            <a
                href="javascript:void(0)"
                @click.prevent="openModalForNewItem"
            >+ Add Subcategory</a>
        </div>

        <CategoryModal
            :modal-id="getCustomModalId(`sub-${subcategory.id}`, activeCategory.index)"
            :title-text="titleText"
            :props-value="activeCategory"
            :main-subcat="subcategory"
            @create="addNewSubcategory"
            @update="updateExistSubcategory"
        />
    </li>
</template>

<script>
import {defineComponent} from 'vue'
import ModalHandler from "../../mixins/ModalHandler";
import CategoryModal from "../Common/CategoryModal.vue";
import draggable from "vuedraggable";

export default defineComponent({
    name: "SubCategoriesList",
    components: {draggable, CategoryModal},
    mixins: [ModalHandler],
    emits: ['delete'],
    props: {
        category: Object,
        index: Number
    },

    computed: {
        subcategory() {
            return this.category
        }
    },
    data() {
        return {
            activeCategory: {},
            titleText: null,
        }
    },
    methods: {
        onDragEnd() {
            this.subcategory.subcategories.forEach((item, index) => {
                item.sortingOrder = index + 1;
            });
        },
        deleteMainSubcategory() {
            if (this.subcategory.id) {
                this.$emit('delete', {id: this.subcategory.id, index: this.index })
            } else {
                this.$emit('delete', {index: this.index})
            }
        },
        deleteSubcategory(subcategory, index) {
            if (subcategory.id) {
                this.$emit('delete', {id: subcategory.id})
                this.subcategory.subcategories.splice(index, 1)
            } else {
                this.subcategory.subcategories.splice(index, 1)
            }
        },
        updateExistSubcategory(result) {
            if(result.index === 'main') {
                this.subcategory.name  = result.name
            } else {
                const index = this.subcategory.subcategories.findIndex(i => i.index === result.index);

                if (index !== -1) {
                    this.subcategory.subcategories.splice(index, 1, {
                        ...this.subcategory.subcategories[index],
                        ...result
                    });
                }
            }
        },

        addNewSubcategory(result) {
            this.subcategory.subcategories.push(result);
        },
        openModal(category, index) {
            this.activeCategory = category
            this.activeCategory.index = index
            this.showCustomModal(`sub-${this.subcategory.id}`, index )
            this.titleText = `Edit subcategory`
        },
        openModalForNewItem() {
            this.activeCategory = { index: 'new', name: '' };
            this.titleText = `Add new subcategory`;
            this.showCustomModal(`sub-${this.subcategory.id}`, `new`);
        },
        editMainSubcategory() {
            this.activeCategory = { index: 'main', name: this.subcategory.name };
            this.titleText = `Edit subcategory`;
            this.showCustomModal(`sub-${this.subcategory.id}`, 'main');
        }
    }

})
</script>


<style scoped>

</style>
